import { DatePickerInput, DatesProvider } from '@mantine/dates';
import 'dayjs/locale/ko';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '../styles/components/mantine.css';
import calendarIcon from '../assets/icons/date-icon.svg';

const MantineDatePicker = ({ value, onChange, zIndex = 1000, withinPortal = false, className, style, ...props }) => {
  const handleChange = (date) => {
    if (onChange) {
      onChange(date);
    }
  };

  return (
    <DatesProvider settings={{ locale: 'ko' }}>
      <DatePickerInput
        value={value}
        leftSection={<img src={calendarIcon} alt="calendar" style={{ width: 16, height: 16 }} />}
        onChange={handleChange}
        placeholder="일자별"
        valueFormat="YYYY-MM-DD"
        locale="ko"
        clearable
        className={`custom-mantine-date-picker ${className || ''}`}
        style={style} 
        popoverProps={{
          withinPortal: withinPortal,
          zIndex: zIndex,
          position: 'bottom-start',
          shadow: 'md'
        }}
        {...props}
      />
    </DatesProvider>
  );
};

export default MantineDatePicker;